import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { kakaoState } from "../../recoil/kakaoState";
import { authState } from "../../recoil/authState";
import { contractModalState } from "../../recoil/contractModalState";
import { checkAuthLevel, createConditionalMenuItems } from "./utils";
import KakaoChatItem from "./components/KakaoChatItem";
import ContractNavItem from "./components/ContractNavItem";
import LogListItem from "./components/LogListItem";
import { trackUiClick } from "../../analytics/analytics";

export default function useBottomNavData() {
  const [Kakao] = useRecoilState(kakaoState);
  const auth = useRecoilValue(authState);
  const setContractModalOpen = useSetRecoilState(contractModalState);
  const clubAdminLevel = auth?.user?.club_admin_level;
  const isNotSBS = checkAuthLevel.isNotSBS(clubAdminLevel);

  const bottomNavData = [
    {
      key: "common",
      name: "일반",
      child: [
        {
          key: "contract",
          name: <ContractNavItem />,
          isBtn: true,
          onClick: () => {
            trackUiClick({
              ui_target_key: 'golf_contract_document',
              element_id: 'contract-button-nav',
              element_text: '골프대행 계약서',
              ui_target_text: '골프대행 계약서',
              ui_area: 'sidebar',
            });
            setContractModalOpen(true);
          },
          child: [],
          isMenuItem: true,
        },
        // SBS일 때는 이용문의 숨김
        ...createConditionalMenuItems(isNotSBS, [
          {
            key: "chat",
            name: <KakaoChatItem />,
            isBtn: true,
            onClick: () => {
              Kakao.teeshot.chat();
            },
            child: [],
            isMenuItem: true,
          },
        ]),
        {
          key: "logList",
          name: <LogListItem />,
          path: "common/logList",
          breadcrumbName: "회원 접속로그",
          child: [],
          requiresMasterAuth: true,
          isMenuItem: true,
        },
      ],
    },
  ];

  return bottomNavData;
}
